module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Regular.ce3b96a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/OpenSans-Regular/OpenSans-Regular.woff
// module id = tzWx
// module chunks = 16